import script from "./HeaderBig.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBig.vue?vue&type=script&setup=true&lang=js"

import "./HeaderBig.vue?vue&type=style&index=0&id=4976049b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4976049b"]])

export default __exports__